import React from 'react';

import { Skeleton } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

export const WorkAssignmentSkeleton = ({ isProblematic = false }) => {
	return (
		<div
			className={`${styles.container} ${isProblematic ? styles.problematic : ''}`}
			aria-live="polite"
			aria-busy="true"
		>
			<div className={styles.summaryRow}>
				<div className={`${styles.block} ${styles.routeBlock}`}>
					<div className={styles.skeletonInlineRow}>
						<Skeleton width="md" height="sm" inline />
						<Skeleton width="md" height="sm" inline extraClasses={styles.inlineOffset} />
					</div>

					<Skeleton width="lg" height="md" Elem="div" extraClasses={styles.routeSubLine} />
				</div>

				<div className={styles.infoStat}>
					<div className={styles.infoStatItemWide}>
						<Skeleton width="md" height="sm" Elem="div" extraClasses={styles.dateLabel} />
						<Skeleton width="lg" height="md" Elem="div" extraClasses={styles.dateValue} />
					</div>

					<div className={styles.infoStatItemWide}>
						<Skeleton width="md" height="sm" Elem="div" extraClasses={styles.dateLabel} />
						<Skeleton width="lg" height="md" Elem="div" extraClasses={styles.dateValue} />
					</div>

					<div className={styles.infoStatItem}>
						<Skeleton width="sm" height="sm" Elem="div" extraClasses={styles.shortLabel} />
						<Skeleton width="sm" height="md" Elem="div" extraClasses={styles.shortValue} />
					</div>

					<div className={styles.infoStatItem}>
						<Skeleton width="md" height="sm" Elem="div" extraClasses={styles.tagLabel} />
						<Skeleton width="md" height="lg" round Elem="div" extraClasses={styles.tagSkeleton} />
					</div>
				</div>

				<div className={`${styles.block} ${styles.name}`}>
					<Skeleton width="lg" height="md" Elem="div" extraClasses={styles.driverName} />
					<Skeleton width="md" height="sm" Elem="div" extraClasses={styles.driverId} />
				</div>
			</div>
		</div>
	);
};

export const WorkAssignmentSkeletonList = () => {
	return (
		<>
			{Array.from({ length: 10 }).map((_, index) => (
				<WorkAssignmentSkeleton key={index} isProblematic={false} />
			))}
		</>
	);
};
